import React from 'react';
import ListAltIcon from '@mui/icons-material/ListAlt';
import HouseIcon from '@mui/icons-material/House';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { getNumberFormat } from 'utils/helpers';
import NoDataMsg from 'library/noData';


const storageIcon = <span className="d-flex align-items-center"><ListAltIcon className="blue-text" /><span className="transferIcons">Storage</span></span>;
const storeIcon = <span className="d-flex align-items-center"><HouseIcon className="green-text" /><span className="transferIcons">Store</span></span>;
const damageIcon = <span className="d-flex align-items-center"><HighlightOffIcon className="danger" /><span className="transferIcons">Damage</span></span>;

const Body = ({ aggregateInventoryLevel }) => (
    <div>
        {
            aggregateInventoryLevel.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div className="pl-2">
                    {
                        aggregateInventoryLevel.map((item, index) => {
                            return (
                                <div className="row m-0 border_bottom_grey mb-1 pb-1 position-relative" key={index}>
                                    <div className="col-lg-5 m-0 p-0 mt-2">
                                        <div className="row m-0">
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 m-0 pl-2 pt-1 reduce-margin-top-report">
                                                <h3 className="m-0 font-weight-semibold purpleText">{item.productName}</h3>
                                                <h6 className='purpleText'>SKU:[{item.sku}] </h6>
                                                <h6 className='purpleText'>UPC:[{item.barcode}] </h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-5 m-0 p-0">
                                        <h3>
                                            All branches:
                                        </h3>
                                        <div className="row m-0">
                                            <div className="col-lg-4 m-0 p-0">
                                                <label>{storageIcon}</label>
                                                <h3 className="m-0 purpleText">{getNumberFormat(item.storageQuantity)}</h3>
                                            </div>
                                            <div className="col-lg-4 m-0 p-0">
                                                <label>{storeIcon}</label>
                                                <h3 className="m-0 purpleText">{getNumberFormat(item.storeQuantity)}</h3>
                                            </div>
                                            <div className="col-lg-4 m-0 p-0">
                                                <label>{damageIcon}</label>
                                                <h3 className="m-0 purpleText">{getNumberFormat(item.damageQuantity)}</h3>
                                            </div>
                                        </div>
                                        {
                                            (item.branchInventoryLevel || []).map((cell, indexX) => {
                                                return (
                                                    <div>
                                                        <h6>
                                                            {cell.branchName}:
                                                        </h6>
                                                        <div className="row m-0">
                                                            <div className="col-lg-4 m-0 p-0">
                                                                <label>{storageIcon}</label>
                                                                <h3 className="m-0 purpleText">{getNumberFormat(cell.storageQuantity)}</h3>
                                                            </div>
                                                            <div className="col-lg-4 m-0 p-0">
                                                                <label>{storeIcon}</label>
                                                                <h3 className="m-0 purpleText">{getNumberFormat(cell.storeQuantity)}</h3>
                                                            </div>
                                                            <div className="col-lg-4 m-0 p-0">
                                                                <label>{damageIcon}</label>
                                                                <h3 className="m-0 purpleText">{getNumberFormat(cell.damageQuantity)}</h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
        }
    </div>
);
export default Body;